import { NftList } from '@components/NftList/NftList'
import { SidebarMobileToggle } from '@components/Sidebar/MobileToggle'
import { Titlebar } from '@components/Titlebar/Titlebar'
import useBalances from '@plug-core/hooks/useBalances'
import React from 'react'

export const NftsOverview = () => {
  const { nftsLoading, loadNfts } = useBalances()

  return (
    <div className="mb-3 flex flex-col gap-4">
      <SidebarMobileToggle title="NFTs" />
      <Titlebar refreshAction={loadNfts} isRefreshing={nftsLoading} />
      <NftList />
    </div>
  )
}
